import { render, staticRenderFns } from "./Persona-touser.vue?vue&type=template&id=ceeb94b2&scoped=true"
import script from "./Persona-touser.vue?vue&type=script&lang=js"
export * from "./Persona-touser.vue?vue&type=script&lang=js"
import style0 from "./Persona-touser.vue?vue&type=style&index=0&id=ceeb94b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceeb94b2",
  null
  
)

export default component.exports